import { memo } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'basic-components'

import './SelectedFooter.scss'

const SelectedFooter = ({ selectedUsersLength, editSelectedUsers, removeSelectedUsers }) => (
  <div className="data-lake__group-dialog__share__selected">
    <div className="data-lake__group-dialog__share__selected__counter">
      {`Selected users: ${selectedUsersLength}`}
    </div>
    <div className="data-lake__group-dialog__share__selected__edit">
      <Button
          onClick={editSelectedUsers}
          size="small"
          type="button"
          variant="secondary"
      >
        Edit
      </Button>
    </div>
    <div className="data-lake__group-dialog__share__selected__remove">
      <Button
          onClick={removeSelectedUsers}
          size="small"
          type="button"
          variant="secondary"
      >
        Remove
      </Button>
    </div>
  </div>
)

SelectedFooter.propTypes = {
  editSelectedUsers: PropTypes.func.isRequired,
  removeSelectedUsers: PropTypes.func.isRequired,
  selectedUsersLength: PropTypes.number.isRequired
}

export default memo(SelectedFooter)
